import React from 'react'
import "../../../styles/pages-styles/main-dashboard-pages-styles/user-sidebar-pages/AlreadySubscribed.css";
import { Check, HomeIcon, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AlreadySubscribed = () => {
  const navigate = useNavigate();

  return (
      <div>
        <div className="subscribe-container">
              <div className="subscribe-header">
                  <Check className="subscribe-icon" size={50} color="#4CAF50" />
            <h1 className="subscribe-title">Already Subscribed</h1>
            <p className="subscribe-subtitle">
              You are already subscribed to the premium plan.
                  </p>
                  <div>
                      <button onClick={() => navigate("/dashboard")}><HomeIcon /> Go Home</button>
                      <button onClick={() => navigate("/dashboard/cancelpage")}><X/> Cancel</button>
                  </div>
          </div>
        </div>
    </div>
  )
}

export default AlreadySubscribed